import { render, staticRenderFns } from "./Rated.vue?vue&type=template&id=1fec5700"
import script from "./Rated.vue?vue&type=script&lang=js"
export * from "./Rated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports